import {useBlockProps} from "@wordpress/block-editor";

export const Save = ({attributes}) => {
    let {justify} = attributes
    return (
        <article style={{display: 'flex', justifyContent: justify}}>
            <a
                className="store-badge"
                id="google-play"
                href="https://play.google.com/store/apps/details?id=com.meetravel&hl=it&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                target={"_blank"}
            >
                <img
                    loading="lazy"
                    alt="Get it on Google Play"
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                />
            </a>
            <a
                className="store-badge"
                href="https://apps.apple.com/it/app/meetravel/id1532228470?itsct=apps_box_badge&amp;itscg=30200"
                target={"_blank"}
            >
                <img
                    loading="lazy"
                    src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1619395200"
                    alt="Download on the App Store"
                />
            </a>
        </article>
    )
}